<script setup>
import { ref } from 'vue'

const version = __APP_VERSION__
const searchTerm = ref('')
//const showResults = ref(false)

//properties set by parent
const props = defineProps({
	dim: {
		type: Object,
		required: true,
	}
})

//events raised by component
const emit = defineEmits(['filteredValues'])

//componenet methods exposed to parent
defineExpose({
    initSearch
});

function initSearch() {
	searchTerm.value = ""
}

async function getSearchResult() {
	if(searchTerm.value.trim().length > 0) {
		let matchedValues = []
		props.dim.appliedValues.forEach(v => {
			if(v.name.toLowerCase().includes(searchTerm.value.trim().toLowerCase()))
				matchedValues.push(v)
		})
		emit('filteredValues', matchedValues)
	} else {
		//reset back to default		
		emit('filteredValues', null)
	}
}

</script>

<template>
	<section class="search-container">
		<div class="search-control" >
			<img src="@/assets/images/search.png" alt="search icon" class="search-img" height="16" width="16">
			<input type="text" name="Search" v-model="searchTerm" class="search-input" maxlength="30" aria-label="Search" @input="getSearchResult" @click="getSearchResult"  placeholder="Search..."/>
		</div>
	</section>
</template>

<style scoped>
.search-container {
	/*margin-top:2.5rem;*/
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
}

.search-img {
	padding: .75rem;
	box-sizing: content-box;
}

.search-control {
	margin-top: 0;
	height: 2.5rem;
	width: 100%;
	background: var(--surface-Default, #FFF);	
    display: flex;
    justify-content: flex-start;
    align-items: center;

	border-radius: 0.25rem;
	border: 1px solid var(--border-color-input-Border, #A9B7C7);
}

.search-input {
	width:100%;
	height: 100%;
    ZZbox-sizing: border-box;
    border: 0;
}
.search-result-wrapper {
	margin-top:.5rem;
	width:100%;
	height: 0;
	max-width: 38.5625rem;
	position: relative;
}
.search-result-wrapper :deep(.search-results) {
	width:100%;
	height:21.5625rem;
	border-radius: 12px;
	border: 1px solid var(--Background-Blue-Gray, #A9B7C7);
	background: var(--surface-Default, #FFF);
	overflow-y: auto;
	/*line-height: var(--font-line-height-Base, 1.5);*/
	/*display: flex;
	justify-content: flex-start;
	float:left;*/
}
.search-results :deep(.search-result-list) {
	list-style-type: none;
	line-height: var(--font-line-height-Base, 1.5);
}
.search-results :deep(.search-result-item) {
	font-family: var(--font-family-Title, Roboto);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;
	font-style: normal;
	background: var(--surface-color-Default);
}
.search-results :deep(.highlight) {
	/*background-color: yellow;*/
	font-weight: 700;
}
.search-results :deep(.search-result-item-h6) {
	color: var(--text-Header, #171717);
	font-size: var(--font-size-H6, 20px);
	font-weight: 500;
	padding-left: 1rem;
	line-height: 1.7; /*var(--font-line-height-H6, 28px);*/ /* 140% */
	/*list-style-type: none;*/
}
.search-results :deep(.search-result-item:hover) {
	background: var(--brand-color-IndicatorsBlue);
	border: 2px solid var(--brand-color-IndicatorsBlue);
	color: var(--text-Inverse);
}
.search-results :deep(.search-result-item:focus) {
	border: 2px solid var(--border-color-DividerActive);
}
.search-results :deep(.search-result-item-medium) {
	color: var(--text-Primary, #2C2C2C);
	font-size: var(--font-size-Base, 16px);
	font-weight: 500;
	padding-left: 2rem;
	line-height: 2;/*var(--font-line-height-Base, 24px);*/ /* 150% */
}
.search-results :deep(.search-result-item-regular) {
	color: var(--text-Primary, #2C2C2C);
	font-size: var(--font-size-Base, 16px);
	font-weight: 400;
	padding-left: 3rem;
	line-height: 2; /*var(--font-line-height-Base, 24px);*/ /* 150% */
}

</style>